module.exports = ol.Overlay;